/* ==============================================================================================
 * TABLE ROW GROUP (CHILD ROWS)
 * ============================================================================================== */

var Sushi;

(function (Sushi, Plugins) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var Events = Sushi.Events;
	var Dom = Sushi.Dom;

	var TableRowGroup = function (triggerElement, options) {
		this.element = triggerElement;

		BasePlugin.call(this, this.element, options);

		this.isOpen = false;
		this.childRows = [];

		var currentElement = $(triggerElement).next();

		while ($(currentElement).hasClass("c-table__row--child")) {
			this.childRows.push($(currentElement)[0]);
			currentElement = $(currentElement).next();
		}

		if (!this.childRows.length) {
			return;
		}

		/**
		 * Updates the group rows' display
		 */
		var updateGroupVisibility = function () {
			var display = this.isOpen ? "table-row" : "none";

			Dom.forEach(this.childRows, function (row) {
				row.style.display = display;
			});
		}.bind(this);

		/**
		 * Toggles the row group visibility
		 */
		var toggleGroupVisibility = function () {
			this.isOpen = !this.isOpen;

			if (this.isOpen) {
				this.element.classList.add("is-open");
			}
			else {
				this.element.classList.remove("is-open");
			}

			updateGroupVisibility();
		}.bind(this);

		updateGroupVisibility();

		Events(this.element).on("click", toggleGroupVisibility);
	};

	TableRowGroup.displayName = "TableRowGroup";

	TableRowGroup.prototype = Object.create(BasePlugin.prototype);

	var proto = TableRowGroup.prototype;

	proto.constructor = TableRowGroup;

	Plugins.TableRowGroup = TableRowGroup;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}));
